export default {
  DEFAULT_LANGUAGE: 'python',
  PRACTICE_MODE: false,  
}